import { Component, HostBinding, Input } from '@angular/core'

@Component({
  selector: 'lin-layout-section-meta',
  templateUrl: './section-meta.component.html',
  styles: [
    `
      :host {
        margin: 0 15px 0 0;
      }
    `,
  ],
  standalone: false,
})
export class SectionMetaComponent {
  @HostBinding('class.h3') h3 = true

  @Input() label: string
  @Input() value: string
  @Input() routerLink: string | any[]
}
